import { render, staticRenderFns } from "./CollectiveAgreements.vue?vue&type=template&id=42f40659"
import script from "./CollectiveAgreements.vue?vue&type=script&lang=js"
export * from "./CollectiveAgreements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports